import React from 'react';
import InfiniteScroll from './InfiniteScroll.tsx';

const statsData = [
  { value: 60, label: 'Reduction in Admin Time', suffix: '%' },
  { value: 95, label: 'Inspection Compliance Achieved', suffix: '%+' },
  { value: 100, label: 'Audit Readiness', suffix: '%' },
  { value: 40, label: 'Faster Equipment Assignments', suffix: '%' },
];

const Stats: React.FC = () => {
  const scrollItems = statsData.map((stat, index) => ({
    content: (
      <div className="text-center p-4">
        <p className="text-4xl md:text-5xl font-bold text-orange-600 dark:text-[#FF4D00]">
          {stat.value}{stat.suffix}
        </p>
        <p className="text-gray-700 dark:text-gray-400 mt-2 text-base">{stat.label}</p>
      </div>
    )
  }));

  return (
    <section className="py-20">
      <div className="container mx-auto px-6">
        <div className="relative h-[400px]">
          <InfiniteScroll
            items={scrollItems}
            isTilted={true}
            tiltDirection="left"
            width="100%"
            maxHeight="400px"
            itemMinHeight={140}
            negativeMargin="-2rem"
          />
        </div>
      </div>
    </section>
  );
};

export default Stats;